<template>
  <div>
    <a-card v-if="queryList">
      <!--<a-row style="position: absolute;top: -70px; width: calc(100% - 70px);" type="flex" justify="space-between" align="bottom">-->
      <!--<a-col :span="12"></a-col>-->
      <!--<a-col :span="12">-->
      <!--<a-row type="flex" justify="center" style="box-sizing: border-box;">-->
      <!--<a-col :span="6">-->
      <!---->
      <!--</a-col>-->
      <!--</a-row>-->
      <!--</a-col>-->
      <!--</a-row>-->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="handleChange" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes1" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes2" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="客户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-row>
                <a-form-item label="客户地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-col :span="6">
                    <a-select
                      v-decorator="['province']"
                      style="margin-right: 10px"
                      @change="haveProvince1"
                      :allowClear="true"
                    >
                      <a-select-option v-for="type in data1" :title="type.provinceName" :key="type.provinceCode">{{
                        type.provinceName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="6">
                    <a-select
                      v-decorator="['city']"
                      style="margin-right: 10px"
                      @change="haveProvince2"
                      :allowClear="true"
                    >
                      <a-select-option v-for="type in data2" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="6">
                    <a-select v-decorator="['area']" style="margin-right: 5px" :allowClear="true">
                      <a-select-option v-for="type in data3" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="6">
                    <a-input v-model.trim="queryParam.clientAddress" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 55px">
                <a-select v-model="queryParam.brandId" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes4" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 55px">
                <a-select v-model="queryParam.modelId" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes5" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                  <a-select-option v-for="type in findByDeptId" :title="type.label" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="审核人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.checker" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                <a-select v-model="queryParam.marketPrincipal" :allowClear="true">
                  <a-select-option v-for="type in marketPrincipal" :title="type.label" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="购买渠道" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.channelName" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes12" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="信息来源" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.sourceName" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes13" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="建单人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.createBy" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="下单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.userOrder" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes8" :title="type.label" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="序列号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.serialNumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="原始订单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                  <a-input v-model.trim="queryParam.originalOrderNo" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 55px">
                  <a-input v-model.trim="queryParam.remarkInfo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.transportCode" :allowClear="true">
                    <a-select-option v-for="type in delivery_company" :title="type.label" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-input v-model.trim="queryParam.transportNo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="退单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.chargebackOrderType" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes10" :title="type.label" :key="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="退单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.chargebackOrderStatus" :allowClear="true">
                    <a-select-option key="0" title="待审核">待审核</a-select-option>
                    <a-select-option key="1" title="通过">通过</a-select-option>
                    <a-select-option key="2" title="不通过">不通过</a-select-option>
                    <a-select-option key="9" title="撤回">撤回</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="退单人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.chargebackOrderMan" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <a-select v-model="queryParam.timeType" style="margin: 0px 16px 0px 0px" :allowClear="true">
                      <a-select-option value="0" title="退单申请时间"> 退单申请时间 </a-select-option>
                      <a-select-option value="1" title="审核时间"> 审核时间 </a-select-option>
                      <a-select-option value="2" title="建单时间"> 建单时间 </a-select-option>
                      <a-select-option value="3" title="预约上门时间"> 预约上门时间 </a-select-option>
                      <a-select-option value="4" title="销单时间"> 销单时间 </a-select-option>
                      <a-select-option value="5" title="核销时间"> 核销时间 </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="18">
                    <a-range-picker
                      style="width: 100%"
                      v-model="queryParam2.time"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChange1"
                      @ok="onOk"
                    />
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="1" :offset="11">
              <span style="cursor: pointer" v-on:click="Ifstatus = !Ifstatus" v-if="!Ifstatus"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span style="cursor: pointer" v-on:click="Ifstatus = !Ifstatus" v-if="Ifstatus"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button htmlType="submit" type="primary" @click="Updata()">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetData()">清空</a-button>
              <a-button v-if="exportEnable" style="margin-left: 8px" type="primary" @click="ExeConcar"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-divider />
        </a-form>
      </div>

      <!--<div class="table-operator">-->
      <!--<a-row>-->
      <!--<a-col :span="10"></a-col>-->
      <!--<a-col :span="4">-->
      <!--</a-col>-->
      <!--<a-col :span="4"></a-col>-->
      <!--<a-col :span="4" style="display: flex;justify-content: flex-end;margin-left: 10px;">-->
      <!--<a-button v-if="addEnable" type="primary" style="background-color: #169BD5;color: white;" icon="plus" @click="$refs.modal.add()">新建</a-button>-->
      <!--</a-col>-->
      <!--</a-row>-->
      <!--</div>-->
      <s-table
        size="default"
        ref="table"
        rowKey="modelId"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 2700 }"
        bordered
      >
        <!--<span slot="installType" slot-scope="text, record">-->
        <!--<td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>-->
        <!--</span>-->
        <span slot="action" slot-scope="text, record" style="white-space: nowrap">
          <a v-if="showDetailsEnable" @click="See(record)">查看</a>

          <a v-if="record.identification == 0" @click="Examine(record)"><a-divider type="vertical" />审核</a>
        </span>
        <span slot="action2" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-for="item in record.remark">
                <p>订单备注:{{ item }}</p>
              </div>
            </template>
            <a type="primary">
              {{ text }}
            </a>
          </a-popover>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copy(record)" /></a>
        </span>
        <span slot="action3" slot-scope="text, record">
          <span>{{ text }}</span>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copy2(record)" /></a>
        </span>
        <span slot="action4" slot-scope="text, record">
          <a-popover :title="text">
            <template slot="content">
              <p>负责人联系方式:{{ record.clientPhone }}</p>
            </template>
            <a>
              {{ text }}
            </a>
          </a-popover>
        </span>
        <span slot="action5" slot-scope="text, record">
          <a-popover :title="text">
            <template slot="content">
              <p>企业全称:{{ text }}</p>
              <p>负责人:{{ record.enterprisePrincipal }}</p>
              <p>联系方式:{{ record.principalPhone }}</p>
              <p>技术人员:{{ record.technology }}</p>
              <p>技术电话:{{ record.technologyPhone }}</p>
              <p>技术人员2:{{ record.technology2 }}</p>
              <p>技术2电话客服负责人:{{ record.technology2Phone }}</p>
              <p>客服负责人:{{ record.customerService }}</p>
              <p>客服负责人电话:{{ record.customerServicePhone }}</p>
            </template>
            <a>
              {{ text }}
            </a>
          </a-popover>
        </span>
      </s-table>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import { getfindByDeptId, getmarketPrincipal } from '@/api/order/orderList'
import { getSelectAllProvince, getelectCityName, getelectAreaName } from '@/api/master/MasterList'
import { checkPermission } from '@/utils/permissions'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  findByDeptId,
  removeOrderList,
  selectBrand,
  getList,
  selectChannel,
  selectSource,
  selectModel,
  exportOrder,
} from '@/api/order/Chargebacks'
import { STable } from '@/components'
import NoAuthority from '../enterprise/NoAuthority'
import { getDictMap } from '../../utils/dict'
import { selectFindAll } from '@/api/enterprise/enterprise'
export default {
  name: 'Chargebacks',
  components: {
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    NoAuthority,
  },
  data() {
    return {
      showDetailsEnable: checkPermission('order:Chargebacks:view:showDetails'),
      exportEnable: checkPermission('order:Chargebacks:view:export'),
      queryList: checkPermission('order:Chargebacks:query:list'),
      viewRestore: checkPermission('order:Chargebacks:view:restore'),
      copyData: null,
      restaurantTypes1: [],
      restaurantTypes2: [],
      order_status: [],
      restaurantTypes4: [],
      restaurantTypes5: [],
      restaurantTypes6: [],
      restaurantTypes7: [],
      restaurantTypes8: [],
      delivery_company: [],
      restaurantTypes10: [],
      restaurantTypes11: [],
      restaurantTypes12: [],
      restaurantTypes13: [],
      findByDeptId: [],
      isOrderOpenedmsg: [],
      marketPrincipal: [],
      queryParam: {},
      queryParam2: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      data1: [],
      data2: [],
      data3: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          width: '70px',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'orderId',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '退单状态',
          dataIndex: 'matterCode',
          align: 'center',
        },
        {
          title: '退单类型',
          dataIndex: 'matterSubtype',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'action2' },
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'substate',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'action5' },
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          scopedSlots: { customRender: 'action4' },
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'action3' },
          align: 'center',
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',

          width: '300px',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '退单申请时间',
          dataIndex: 'auditTime',
          align: 'center',
        },
        {
          title: '审核时间',
          dataIndex: 'checkTime',
          align: 'center',
        },
        {
          title: '审核人',
          dataIndex: 'checker',
          align: 'center',
        },
      ],
      loadData: (parameter) => {
        return removeOrderList(Object.assign(parameter, this.queryParam))
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      form: this.$form.createForm(this),
      pagination: false,
      loading: false,
      Ifstatus: false,
    }
  },
  async created() {
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
    this.marketPrincipal = []
    await getmarketPrincipal().then((res) => {
      //console.log(res)
      this.marketPrincipal = res
    })
    this.restaurantTypes1 = [] //安装类别
    this.restaurantTypes4 = []
    this.restaurantTypes5 = []
    this.restaurantTypes6 = []
    this.restaurantTypes7 = []
    this.restaurantTypes8 = []
    this.restaurantTypes10 = []
    this.restaurantTypes11 = []
    this.restaurantTypes12 = []
    this.restaurantTypes13 = []
    selectFindAll({ dictTypes: 'install_type,order_status,under_order_type,delivery_company' }).then((res) => {
      // this.restaurantOperTypeMap = await getDictMap('worker_type');
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap1.forEach((value, key) => {
        this.restaurantTypes1.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap8 = res.under_order_type
      this.restaurantOperTypeMap8.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes8.push({ code: value.dictValue, label: value.dictLabel })
      })
      // 字典为订单超时状态
      this.delivery_company = []
      this.restaurantOperTypeMap = res.delivery_company
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.delivery_company.push({ code: value.dictValue, label: value.dictLabel })
        // console.log(this.restaurantTypes)
      })
      // 字典为订单状态
      this.order_status = []
      this.restaurantOperTypeMap = res.order_status
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.order_status.push({ code: value.dictValue, label: value.dictLabel })
        // console.log(this.restaurantTypes)
      })
    })
    findByDeptId('104').then((res) => {
      //市场负责人
      console.log(res, '负责人')
      res.forEach((value, key) => {
        this.restaurantTypes7.push({ code: value.userId, label: value.userName })
      })
    })
    findByDeptId('112').then((res) => {
      //订单负责人
      res.forEach((value, key) => {
        this.restaurantTypes6.push({ code: value.userId, label: value.userName })
      })
    })

    selectBrand().then((res) => {
      //品牌this.restaurantTypes4
      let that = this
      res.data.forEach((key, value) => {
        that.restaurantTypes4.push({ code: key.brandId, label: key.brandName })
      })
    })

    selectChannel().then((res) => {
      //购买渠道
      // console.log(res)
      let that = this
      res.data.forEach((key, value) => {
        that.restaurantTypes12.push({ code: key.channelId, label: key.channelName })
      })
    })
    selectSource().then((res) => {
      //信息来源
      let that = this
      res.data.forEach((key, value) => {
        that.restaurantTypes13.push({ code: key.sourceId, label: key.sourceName })
      })
    })
    selectModel().then((res) => {
      //查询型号
      let that = this
      res.data.forEach((key, value) => {
        that.restaurantTypes5.push({ code: key.modelId, label: key.modelName })
      })
    })
    // 标签
    // 省
    getSelectAllProvince().then((res) => {
      // console.log(res)
      this.data1 = res.rows
    })
  },

  methods: {
    // empty(){
    //   this.queryParam={}
    //   this.dateString=''
    // },
    moment,
    onChange1(value, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    ExeConcar() {
      this.queryParam.city = this.form.getFieldValue('city')
      this.queryParam.area = this.form.getFieldValue('area')
      this.queryParam.province = this.form.getFieldValue('province')

      var str = process.env.VUE_APP_API_BASE_URL + '/order/remove/exportOrder?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)

      //
      // exportOrder(this.queryParam).then(res=>{
      //   console.log(res)
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = '退单列表'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    resetData() {
      this.queryParam = {}
      this.queryParam2 = {}
      this.form.resetFields()
    },
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    Updata() {
      this.queryParam.city = this.form.getFieldValue('city')
      this.queryParam.area = this.form.getFieldValue('area')
      this.queryParam.province = this.form.getFieldValue('province')
      this.$refs.table.refresh(true)
    },
    Copy(val) {
      this.copyData =
        `订单号:` +
        val.orderNo +
        '\n' +
        `客户姓名:` +
        val.enterprisePrincipal +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },
    Copy2(val) {
      this.copyData =
        `客户姓名:` +
        val.enterprisePrincipal +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },
    handcopy(data) {
      let url = data
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    haveProvince1(e) {
      this.data3 = []
      this.data2 = []
      this.form.setFieldsValue({
        area: '',
      })
      this.form.setFieldsValue({
        city: '',
      })
      getelectCityName({ provinceCode: e }).then((res) => {
        this.data2 = res.rows
      })
    },
    handleChange(val) {
      this.restaurantTypes2 = []
      var that = this
      getList(val).then((res) => {
        console.log(res)
        res.rows.forEach((value, key) => {
          that.restaurantTypes2.push({ code: value.orderTypeId, label: value.typeName })
        })
      })
    },
    //查看
    See(id) {
      this.$refs.editorder.showeditOrder(id.orderId, 1, 0)
    },
    haveProvince2(e) {
      this.data3 = []
      this.form.setFieldsValue({
        area: '',
      })
      getelectAreaName({ cityCode: e }).then((res) => {
        this.data3 = res.rows
      })
    },
    //审核
    Examine(id) {
      this.$refs.editorder.showeditOrder(id.orderId, 1, 1)
    },
  },
}
</script>

<style scoped>
.trebtn {
  width: 140px;
  color: white;
  background-color: #17a4e1;
  font-size: 15px;
  top: -90px;
  right: 100px;
}

.copy {
  position: relative;
  top: -10px;
  right: -10px;
}
.treth {
  right: 248px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 6px 16px;
}
</style>